import React from 'react'
import { Field } from 'formik'
import { renderParagraphWithLinks } from '../../Utilities/RichTextRenderer'
import { getDefaultValidator } from '../formUtils/stringValidator'

function ConsentCheckboxField(field) {
  const { message, nameField, fieldType, checkboxData } = field
  const text = renderParagraphWithLinks(message)
  return (
    <label className="consent-checkbox-label">
      <Field
        type="checkbox"
        name={nameField}
        className="form__input--checkbox"
        validate={getDefaultValidator(checkboxData, fieldType)}
      />
      {text}
    </label>
  )
}

export default ConsentCheckboxField
